
<mat-dialog-content data-testid="retrigger-dialog">
  <div class="flex space-between">
    <h1>Retrigger tree</h1>
    <div class="flex space-between">
      <button class="btn-secondary" (click)="hideModal()">cancel</button>
      <button class="ml-2" (click)="updateTree()">Save</button>
    </div>
  </div>
  <h3>Select tree</h3>
  <div class="flex flex-container">
    <p data-testid="tree-pill" class="pill" [ngClass]="{'selected': tree.value === selectedTree}" (click)="selectedTree = tree.value" *ngFor="let tree of treeOptions">{{tree.label}}</p>
  </div>
  <h3>Select main concern</h3>
  <div class="flex flex-container">
    <p data-testid="main-concern-pill" class="pill" [ngClass]="{'selected': mainConcern?.get('value') === userConcern}" (click)="updateMainConcern(mainConcern)" *ngFor="let mainConcern of mainConcernOptions">{{mainConcern.get('value')}}</p>
  </div>
</mat-dialog-content>